import { render, staticRenderFns } from "./Activity_ideas.vue?vue&type=template&id=77ef7310"
import script from "./Activity_ideas.vue?vue&type=script&lang=js"
export * from "./Activity_ideas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports